import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangeControlLibraryComponent } from './components/change-control-library/change-control-library.component';

const routes: Routes = [{ path: '', component: ChangeControlLibraryComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChangeControlLibraryRoutingModule { }
